/* eslint-disable no-unused-vars */
import { getStore } from "./services/store";
import { App } from "./services/action";

export default async function bootstrap() {
  const { dispatch } = getStore();

  await dispatch(App.$appReady());
}
